import { useMemo } from "react";
import { useDeviceSize } from "@hooks/device-size";
import { getVehicleImageUrl, formatPrice, formatOdometer } from "@/utils/helpers";

import type {
  TVehicleInformationsConfig,
  TVehicleInformationsLogicResult,
} from "./vehicle-informations.types";

/** Formata dados do veículo (imagem, preço, km) para exibição no header da conversa. */
export const useVehicleInformationsLogic = ({
  lead,
}: TVehicleInformationsConfig): TVehicleInformationsLogicResult => {
  const { isMobile } = useDeviceSize();
  const isDesktop = !isMobile;

  const isLeadInvalid = !(lead?.advertiseId && lead.brand && lead.year);

  const vehicleImage = useMemo(() => {
    if (isLeadInvalid) return null;
    return getVehicleImageUrl(lead.photoPath, lead.vehicleType ?? '');
  }, [lead, isLeadInvalid]);

  if (isLeadInvalid) {
    return {
      isDesktop,
      isLeadInvalid: true,
      vehicleImage: null,
      city: undefined,
      state: undefined,
      title: undefined,
      formattedPrice: '',
      formattedOdometer: '',
      year: undefined,
      advertiseUrl: undefined,
    };
  }

  const { city, state, title, price, odometer, year, advertiseUrl } = lead;

  const formattedPrice = formatPrice(price);
  const formattedOdometer = formatOdometer(odometer);

  return {
    isDesktop,
    isLeadInvalid: false,
    vehicleImage: vehicleImage ?? '',
    city,
    state,
    title,
    formattedPrice,
    formattedOdometer,
    year,
    advertiseUrl,
  };
};
